module.exports = __webpack_public_path__ + "media/images/avatar-a939a34fa9ee9e024f57fb9a469e495c.png";